import _ from 'lodash';
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { RootState } from '@/src/reducers/types';
import { cn } from '@/src/util/ui';

import Folders from '../Folders';

const Folder = ({
  file,
  onToggler,
  togglers,
  onSetSelected,
  selected = null,
  disabled = false,
  originalSelected = null,
}) => {
  const files = useSelector((store: RootState) => store.files);
  const subfolders = file.children || [];

  const onToggle = (e = null) => {
    if (e) e.preventDefault();
    onToggler(togglers.includes(file.id), file.id);
  };

  const handleClickSubfolder = (e) => {
    e.preventDefault();
    onToggle();
    onSetSelected(file);
  };

  const isDisabled = selected?.id === file.id || originalSelected?.id === file.id || disabled;
  return (
    <li className={cn(`folderRow`)}>
      <div
        className={`folderRowWrapper ${
          files.selected.id === file.id ||
          files.list.filter((f) => f.isSelected && f.id === file.id).length > 0 ||
          disabled
            ? 'disabled'
            : ''
        } ${selected?.id === file.id ? 'active' : ''}`}
      >
        <a
          className={`accordion-toggle collapsed arrowContainer ${
            togglers.indexOf(file.id) > -1 ? 'toggled' : ''
          }`}
          data-toggle="collapse"
          href={`#move-collapse-${file.id}`}
          role="button"
          aria-expanded="false"
          aria-controls={`move-collapse-${file.id}`}
          onClick={(e) => handleClickSubfolder(e)}
        >
          {!!subfolders.length && <i className={`material-icons arrowIcon `} />}
        </a>
        <a
          className={`link-anchor ${isDisabled ? 'disabled' : ''}`}
          data-toggle="collapse"
          href={`#move-collapse-${file.id}`}
          role="button"
          aria-expanded="false"
          aria-controls={`move-collapse-${file.id}`}
          onClick={handleClickSubfolder}
        >
          <i className="material-icons">folder</i>
          {file.name}
        </a>
      </div>
      <div
        className={`collapse subfoldersContainer ${subfolders.length === 0 ? 'displayNone' : ''}`}
        id={`move-collapse-${file.id}`}
      >
        {subfolders.length > 0 && (
          <ul className="folderListContainer">
            <Folders
              folders={subfolders}
              onToggler={onToggler}
              togglers={togglers}
              selected={selected}
              onSetSelected={onSetSelected}
              originalSelected={originalSelected}
            />
          </ul>
        )}
        {subfolders.length === 0 && <p>No results found.</p>}
      </div>
    </li>
  );
};

export default Folder;
